import { defineComponent, h } from 'vue';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { ItemProps } from '@/ui/components/inspectionReport/types';

export const ConditionalSection = defineComponent<ItemProps>({
  name: 'ConditionalSection',
  props: ['item'],
  setup(props) {
    return function render() {
      if (props.item.allConditionsMet === false) {
        return null;
      }

      return props.item.items ? h('div', [...useInspectionReport().getSubItems(props.item.items)]) : null;
    };
  },
});
